export const MAPBOX_TOKEN = 'pk.eyJ1IjoidG9tY2FuamkiLCJhIjoiY201MmZwOWxyMXJsYzJpc2ZhMmxhYmt1OSJ9.I-eYf-nFcaEyxNaAteF-Ww';